//#region redux
import { ThunkDispatch } from "redux-thunk";
import { displayDialog } from "store/actions/utilActions";
import { useDispatch } from "react-redux";
//#endregion
//#region types
import { LocalizationHelperInstance } from "utils/helpers";
import { DialogEnums, StyleEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import WintCardDialogContent from "./dialogContent";
import WintCardStackImg from "images/wintcard-stack.png";
//#endregion
import cssExports from "theme/styles/main.module.scss";

function useWintCardPromotionDialog() {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const openDialog = async () => {
    const dialog: DialogProps = {
      isOpen: false,
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Receipt.WintCardPromotionHeader),
      dialogType: DialogEnums.DialogType.WalkingMan,
      type: StyleEnums.DisplayType.Info,
      children: <WintCardDialogContent />,
      maxWidth: "md",
      customContent: <img src={WintCardStackImg} className={cssExports.walkingMan} />,
      className: cssExports.wintCardPromotionDialogRoot,
    };

    dispatch(displayDialog(dialog));
  };

  return {
    openDialog: openDialog,
  };
}

export default useWintCardPromotionDialog;
